import {
  Directive,
  ElementRef,
  inject,
  Input
} from '@angular/core';

import { ASSETS_DIR } from '../tokens';

const PLACEHOLDERS = {
  AK_SVG: 'ak.svg',
  AK47_SVG: 'ak47.svg',
  AK47: 'ak47.webp',
  AWP: 'awp.webp',
  GLOCK_SVG: 'glock.svg',
  KARAMBIT_KNIFE_SVG: 'karambit_knife.svg',
  KNIFE: 'knife.webp',
  M4A4: 'm4a4.webp',
  MP5SD_SVG: 'mp5sd.svg',
  PISTOL: 'pistol.svg',
  SHADOW_KNIFE: 'shadow_knife.svg',
  URSUS_KNIFE: 'ursus_knife.svg',
  COIN: 'coin.webp'
};

@Directive({
  selector: 'img[itemPlaceholder]'
})
export class ItemPlaceholderDirective {
  @Input()
  set itemPlaceholder(name: keyof typeof PLACEHOLDERS) {
    const { nativeElement } = this.elementRef;
    const hasClasses = ['image', 'image_preload'].every(className => nativeElement.classList.contains(className));

    if(!hasClasses) {
      nativeElement.classList.add('image', 'image_preload');
    }

    nativeElement.setAttribute('src', `${ this.assetsDir }/images/items-placeholder/${ PLACEHOLDERS[name] }`);
  }

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly assetsDir = inject(ASSETS_DIR);
}